import React from 'react';
import { useTranslation } from 'react-i18next';
export const FaqSection = () => {
    const { t } = useTranslation('marketing');
    const faq = t('faq', { returnObjects: true });
    return (<div className="mt-14 grid gap-6 md:grid-cols-2 text-xs text-muted-foreground">
            {['q1', 'q2', 'q3', 'q4'].map((key) => (<div key={key}>
                    <h2 className="mb-2 text-sm font-semibold">{faq[key].question}</h2>
                    <p>{faq[key].answer}</p>
                </div>))}
        </div>);
};
